import { render } from "./SearchTopTemplate.vue?vue&type=template&id=10ccf8a1&scoped=true"
import script from "./SearchTopTemplate.vue?vue&type=script&lang=js"
export * from "./SearchTopTemplate.vue?vue&type=script&lang=js"

import "./SearchTopTemplate.vue?vue&type=style&index=0&id=10ccf8a1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10ccf8a1"

export default script